<template>
  <b-modal size="lg" :visible="visible" no-close-on-backdrop no-close-on-esc centered>
    <div slot="modal-header" class="w-100">
      <h5>{{ title }}
        <button type="button" class="close" @click.prevent="closeModal()"><span aria-hidden="true">&times;</span>
        </button>
      </h5>
    </div>
    <div class="container-fluid">
      <div v-if="generalErrorMessage" class="row">
        <div class="col">
          <div class="alert alert-danger" role="alert">
            {{ generalErrorMessage }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-2"></div>
        <div class="col-8">
          <b-form-group :label-cols="5" label="Code" :state="stateForField('code')" :invalid-feedback="errorForField('code')" label-class="text-right">
            <b-form-input v-model="ascFeeScheduleCode.code"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="5" label="Modifier" :state="stateForField('modifier')" :invalid-feedback="errorForField('modifier')" label-class="text-right">
            <b-form-input v-model="ascFeeScheduleCode.modifier"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="5" label="Description" :state="stateForField('description')" :invalid-feedback="errorForField('description')" label-class="text-right">
            <b-form-input v-model="ascFeeScheduleCode.description"></b-form-input>
          </b-form-group>
          <b-form-group :label-cols="5" label="Discount Eligible" :state="stateForField('discountEligible')" :invalid-feedback="errorForField('discountEligible')" label-class="text-right">
            <b-form-radio-group v-model="ascFeeScheduleCode.discountEligible" class="pt-2" :options="yesNoOptions"/>
          </b-form-group>
          <b-form-group :label-cols="5" label="Fee" :state="stateForField('fee')" :invalid-feedback="errorForField('fee')" label-class="text-right">
            <b-input-group prepend="$"><b-form-input v-model="ascFeeScheduleCode.fee"></b-form-input></b-input-group>
          </b-form-group>
        </div>
        <div class="col-2 col-offset"></div>
      </div>
    </div>
    <div slot="modal-footer" class="w-100">
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="saveFeeScheduleCode()">
        <i v-if="isSaving" class="fa fa-spinner fa-spin"></i> Save
      </button>
      <button type="button" class="btn btn-outline-orange m-1 wide-button float-right" @click.prevent="closeModal()">Close
      </button>
    </div>
  </b-modal>
</template>

<script>
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import api from '../services/api'
  import _ from 'lodash'

  export default {
    name: 'AscFeeScheduleCodesModal',

    mixins: [ErrorsMixin],

    props: {
      visible: {
        type: Boolean,
        required: true
      },

      editAscFeeScheduleCode: {
        type: Object,
        required: false
      },

      ascFeeScheduleId: {
        type: Number,
        required: true
      }
    },

    data () {
      return {
        ascFeeScheduleCode: {},
        yesNoOptions: [
          { value: true, text: 'Yes' },
          { value: false, text: 'No' }
        ],
        isSaving: false,
        feeScheduleId: 0
      }
    },

    watch: {
      editAscFeeScheduleCode (newValue) {
        if (newValue.organizationAscFeeScheduleCodeId) {
          this.ascFeeScheduleCode = _.clone(newValue)
        } else {
          this.ascFeeScheduleCode = {
            organizationAscFeeScheduleId: this.ascFeeScheduleId
          }
        }
      },
      ascFeeScheduleId (newValue) {
        if (newValue) {
          this.feeScheduleId = _.clone(newValue)
        }
      }
    },

    computed: {
      title () {
        if (this.ascFeeScheduleCode && this.ascFeeScheduleCode.organizationAscFeeScheduleCodeId) {
          return 'Edit Code'
        }
        return 'Create Code'
      }
    },

    methods: {
      validate () {
        this.clearAllErrors()

        if (!this.ascFeeScheduleCode.code) {
          this.addErrorForField('code', 'You must enter a code')
        }

        if (this.ascFeeScheduleCode.discountEligible === null) {
          this.addErrorForField('discountEligible', 'You must select an option')
        }

        if (!this.ascFeeScheduleCode.fee) {
          this.addErrorForField('fee', 'You must enter a fee')
        }

        return !this.hasErrors()
      },
      closeModal () {
        this.$emit('update:visible', false)
      },
      saveFeeScheduleCode () {
        if (!this.validate()) {
          return
        }
        if (this.isSaving === true) {
          return
        }
        this.isSaving = true
        api.post('Dashboard/AscFeeSchedules/' + this.ascFeeScheduleId + '/Codes', this.ascFeeScheduleCode).then(response => {

          this.isSaving = false
          this.$emit('updated', response)
          this.ascFeeScheduleCode = {}
        }).catch(error => {
          this.isSaving = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.setFromApiErrorResponse(error)
          }
        })
      }
    }
  }
</script>
